module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#photo",
      toString: function () {
        return this.url;
      }
    }